import React, { Component } from 'react';
import { connect } from 'react-redux';
import { notificationsActions } from '../../../data/actions/notifications';
import store from '../../../helpers/store';
import Spinner from '../../common/Spinner';

class ChangelogLink extends React.Component {
	constructor(props){
		super(props);
		this.open = this.open.bind(this);
	}
	
	open(){
		const { changelog } = this.props.notifications;
		if(changelog && changelog.length > 0) { // mark as read, saving last log entry  
			const id = changelog[0].id;
			store.set('lastNotificationID', id);	
		} 
			
		this.props.dispatch(notificationsActions.setChangelogPanel(true));
		document.body.style.overflow = "hidden";
	}
	
	render() {
		const { changelogCount, changelogLoading } = this.props.notifications;
		return <div className={`whats-new-container ${changelogCount > 0 ? ' active':''}`}>
			<p className="whats-new-option" onClick={this.open}>
				What's New 
				{changelogLoading && <div className="whats-new-spinner"><Spinner enabled={true} /></div>}
				<span className={`badge ${changelogCount > 0 ? ' badge-active':''}`}> {changelogCount}</span>
			</p>
		</div>
	}
}

function mapStateToProps(state) {
	return {
		notifications: state.notifications
	} 
}

export default connect(mapStateToProps)(ChangelogLink);